import React from 'react';
import { Shield, Users, Leaf, Globe, Target, Heart } from 'lucide-react';
import Header from '../components/landing/Header';
import Footer from '../components/landing/Footer';
import { useLanguage } from '../context/LanguageContext';

const AboutPage = () => {
  const { t } = useLanguage();

  const valuesConfig = [
    { key: 'cyber', icon: Shield },
    { key: 'youth', icon: Users },
    { key: 'environment', icon: Leaf },
    { key: 'global', icon: Globe },
    { key: 'entrepreneurship', icon: Target },
    { key: 'social', icon: Heart },
  ];

  return (
    <div className="min-h-screen bg-[#060b1a]">
      <Header />
      
      {/* Hero Section */}
      <section className="relative pt-32 pb-20 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-[#060b1a] via-[#0a1628] to-[#0f1f33]" />
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#4DFF88]/10 rounded-full blur-[150px]" />
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#4DD6FF]/10 rounded-full blur-[120px]" />
        
        <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1 rounded-full border border-[#4DFF88]/30 bg-[#4DFF88]/5 text-[#4DFF88] text-sm font-medium mb-6">
              {t('about.badge')}
            </span>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-semibold text-white mb-6">
              {t('about.title')}
            </h1>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="relative py-16 bg-[#060b1a]">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Introduction */}
          <div className="mb-16">
            <div className="p-8 rounded-2xl border border-white/10 bg-white/5 backdrop-blur-sm">
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                <span className="text-[#4DFF88] font-semibold">{t('about.intro1').split(';')[0]};</span>
                {t('about.intro1').split(';')[1]}
              </p>
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                {t('about.intro2')}
              </p>
              <p className="text-lg text-gray-300 leading-relaxed mb-6">
                {t('about.intro3')}
              </p>
              <p className="text-lg text-gray-300 leading-relaxed">
                {t('about.intro4')}
              </p>
            </div>
          </div>

          {/* Values Grid */}
          <div className="mb-16">
            <h2 className="text-2xl sm:text-3xl font-semibold text-white mb-8 text-center">
              {t('about.valuesTitle')}
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {valuesConfig.map((value, index) => (
                <div
                  key={index}
                  className="group p-6 rounded-xl border border-white/10 bg-white/5 hover:border-[#4DFF88]/30 hover:bg-[#4DFF88]/5 transition-all duration-300"
                >
                  <div className="w-12 h-12 rounded-lg bg-[#4DFF88]/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                    <value.icon className="w-6 h-6 text-[#4DFF88]" />
                  </div>
                  <h3 className="text-lg font-semibold text-white mb-2">
                    {t(`about.values.${value.key}.title`)}
                  </h3>
                  <p className="text-gray-400 text-sm">
                    {t(`about.values.${value.key}.desc`)}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
